import { useState } from "react"


function colorCombinationString(colorIndex, colorValues, trend) {
  return <span>{colorIndex + 1}. {colorValues.color1} {trend.set1Value}  &times; {colorValues.color2} {trend.set2Value} - {colorValues.count}</span>

}

const HotPairColorOptions = ({ trend }) => {


  const [selectedColorOption, setSelectedColorOption] = useState(null)


  const selectCOlorButtonHandler = (e) => {
    const index = e.target.parentElement.dataset.id
    const nextColorOption = trend.colorOptions[index]
    if (!nextColorOption) {
      return
    }
    if (!selectedColorOption || selectedColorOption.color1 != nextColorOption.color1 || selectedColorOption.color2 != nextColorOption.color2)
      setSelectedColorOption(nextColorOption)
    else
      setSelectedColorOption(null)
  }
  return <div className="w-full mt-2">
    <div className="px-2"><strong>COLOR OPTIONS: </strong>{trend.colorOptions
      .filter(col => col.color1 && col.color2)
      .map((col, colId) => <button
        data-id={colId}
        onClick={selectCOlorButtonHandler}
        className={`font-semibold px-2 mx-1 rounded my-[0.5px] ${selectedColorOption && selectedColorOption.color1 == col.color1 && selectedColorOption.color2 == col.color2 ? 'bg-slate-200' : ''}`}
      >{colorCombinationString(colId, col, trend)}</button>)}
    </div>
    {selectedColorOption ? <div className="border-y ">
      <h2 className="font-semibold text-xl px-4">{selectedColorOption.color1} {trend.set1Value}  &times; {selectedColorOption.color2} {trend.set2Value}  images</h2>
      <div className="flex w-full overflow-x-auto">
        {selectedColorOption.images.map(im => <div className="h-60 px-1 w-auto shrink-0"><img src={im.imageUrl} className='h-full' /></div>)}
      </div>
    </div> : null}


  </div>

}

export default HotPairColorOptions 
